import {createApi} from "@reduxjs/toolkit/query/react";
import api from "@/store/api/api";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import CookieManager from "@/managers/cookie.manager";

export const impersonateApi = createApi({
    reducerPath: 'impersonateApi',
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        companyAuth: build.mutation({
            query: ({...data}) => ({
                url: api.impersonate.companyAuth(),
                method: 'POST',
                body: data,
            }),
        }),
    })
})

export const { useCompanyAuthMutation } = impersonateApi